if (!customElements.get('util-countdown')) {
  class UtilCountdown extends HTMLElement {
    constructor() {
      super();
      this.countDownDate = new Date(this.dataset.date).getTime();
      this.countdown = this.querySelector('.util-countdown');
      this.numbersStyle = this.dataset.numbersStyle;
      this.tick();
    }
  
    tick() {
      var now = new Date().getTime();
      var distance = this.countDownDate - now;
      // Time calculations for days, hours, minutes and seconds
      var days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0').split('');
      var hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0').split('');
      var minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0').split('');
      var seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0').split('');
      var html = '';

      if (this.dataset.showDays=="true") {
        html += `
          <div class="group days">
            <div class="numbers flex `+ this.numbersStyle +`"><span>` + days[0] + `</span><span>` + days[1] + `</span></div>
            <div class="small-label">Days</div>
          </div>
          <div class="dash">:</div>
        `;
      }

      html += `
        <div class="group hours">
          <div class="numbers flex `+ this.numbersStyle +`"><span>` + hours[0] + `</span><span>` + hours[1] + `</span></div>
          <div class="small-label">Hours</div>
        </div>		
        <div class="dash">:</div>
        <div class="group minutes">
          <div class="numbers flex `+ this.numbersStyle +`"><span>` + minutes[0] + `</span><span>` + minutes[1] + `</span></div>
          <div class="small-label">Minutes</div>
        </div>		
        <div class="dash">:</div>
        <div class="group seconds">
          <div class="numbers flex `+ this.numbersStyle +`"><span>` + seconds[0] + `</span><span>` + seconds[1] + `</span></div>
          <div class="small-label">Seconds</div>
        </div>`;

        this.countdown.innerHTML = html;
  
        if (distance < 0) {
          this.countdown.remove();
          this.querySelector('.util-countdown-default').style.display = 'block';
          var msgRunning = this.querySelector('.util-countdown-running');
          if (msgRunning) {
            msgRunning.style.display = 'none';
          }
        } else {
          setTimeout(this.tick.bind(this), 1000);
        }
    }
  };

  customElements.define('util-countdown', UtilCountdown);
}